mutation DeleteMembers(
  $workspaceId: ID!
  $memberIds: [ID]!
) {
  result: deleteMembers(
    workspaceId: $workspaceId
    memberIds: $memberIds
  )
}
